import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";
import { request } from "../request/request";

const initialState = {
    categories: [],
    data: {},
    loadingStatus: "idle",
    error: null
}

export const fetchVehiclesEditFields = createAsyncThunk(
    'vehiclesEditFields/fetchVehiclesEditFields',
    async ({token, id}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = await request(
                `${APP_URL}/vehicles/${id}/edit`,
                'GET',
                null,
                customHeaders
            )

            return response;
        } catch (error) {
            rejectWithValue(error.status);
        }
    }
)

const vehiclesEditFields = createSlice({
    name: 'vehiclesEditFields',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchVehiclesEditFields.pending, (state) => {
                state.categories = [];
                state.data = {};
                state.loadingStatus = "loading";
                state.error = null;
            })
            .addCase(fetchVehiclesEditFields.fulfilled, (state, action) => {
                state.categories = action.payload.categories || [];
                state.data = action.payload.data || null;
                state.loadingStatus = "idle";
                state.error = null;
            })
            .addCase(fetchVehiclesEditFields.rejected, (state, action) => {
                state.categories = [];
                state.data = {};
                state.loadingStatus = "error";
                state.error = action.payload;
            })
    }
});

export default vehiclesEditFields.reducer;